export const depositoClienteFilterConfig = [
  {
    id: 'Id',
    type: 'number',
    label: 'Id',
    placeholder: 'Id do cliente'
  },
  {
    id: 'NomeCliente',
    type: 'text',
    label: 'Nome Cliente',
    placeholder: 'Digite o nome do cliente'
  },
  {
    id: 'CNPJCliente',
    type: 'text',
    label: 'CNPJ',
    placeholder: 'Digite o CNPJ'
  },
  {
    id: 'TokenRastreamento',
    type: 'text',
    label: 'Token',
    placeholder: 'Token de rastreamento'
  },
  {
    id: 'TokenRastreamentoAtivo',
    type: 'select',
    label: 'Token Ativo',
    placeholder: 'Selecione...',
    options: [
      { label: 'Sim', value: 'true' },
      { label: 'Nao', value: 'false' }
    ]
  },
  {
    id: 'DiasRecorrencia',
    type: 'number',
    label: 'Dias Recorrencia',
    placeholder: 'Intervalo em dias'
  },
  {
    id: 'DataCriacaoInicio',
    type: 'date',
    label: 'Data Criacao (Inicio)'
  },
  {
    id: 'DataCriacaoFim',
    type: 'date',
    label: 'Data Criacao (Fim)'
  },
  {
    id: 'DataAtualizacaoInicio',
    type: 'date',
    label: 'Data Atualizacao (Inicio)'
  },
  {
    id: 'DataAtualizacaoFim',
    type: 'date',
    label: 'Data Atualizacao (Fim)'
  }
];
